const RCC_COMMENT_ROLES = new Set(["APR_RCC", "RCC_USER"]);

export function isRccCommentRole(role) {
  return RCC_COMMENT_ROLES.has(String(role || "").toUpperCase());
}

export function isAprCommentRole(role) {
  return String(role || "").toUpperCase() === "APR_USER";
}

export function isNdpcViewer(viewerRole) {
  return String(viewerRole || "").toUpperCase() === "NDPC_USER";
}

export function normalizeAprReportRole(user) {
  const reportRole =
    user?.user?.userRoles?.find((role) =>
      ["APR USER", "RCC USER", "NDPC USER"].includes(role.name),
    )?.name || "";
  return reportRole ? reportRole.replace(" ", "_").toUpperCase() : "";
}

/** NDPC users must not see internal RCC review comments. */
export function filterCommentsForViewer(comments, viewerRole) {
  if (!isNdpcViewer(viewerRole)) {
    return comments;
  }
  return comments.filter((comment) => !isRccCommentRole(comment.userRole));
}

/** NDPC users must not see APR user names on district-authored content. */
export function shouldShowCommentAuthorToViewer(comment, viewerRole) {
  if (!isNdpcViewer(viewerRole)) return true;
  return !isAprCommentRole(comment.userRole);
}
